// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Navbar";

// Pages
import HomePage from "./pages/HomePage";
import PackagesPage from "./components/PackagesPage";
import DepositPage from "./pages/DepositPage";
import WithdrawPage from "./pages/WithdrawPage";
import DailyClaimPage from "./pages/DailyClaimPage";
import SettingsPage from "./pages/SettingsPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignupPage";

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        {/* Navbar always visible */}
        <Navbar />

        {/* Page Content */}
        <div className="flex-1 pt-20">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/packages" element={<PackagesPage />} />
            <Route path="/deposit" element={<DepositPage />} />
            <Route path="/withdraw" element={<WithdrawPage />} />
            <Route path="/daily-claim" element={<DailyClaimPage />} />
            <Route path="/settings" element={<SettingsPage />} />

            {/* Auth Pages */}
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/signup" element={<SignUpPage />} />

            {/* fallback: redirect to home if route not found */}
            <Route path="*" element={<HomePage />} />
          </Routes>
        </div>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-4 text-center">
          <p className="text-sm">&copy; {new Date().getFullYear()} DiamondApp. All rights reserved.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
